import { orderListApi, orderInfoApi, orderInstrumentApi, orderMaterialListApi, orderMaterialDescApi, orderOrgPayApi, orderMsgListApi } from '@/api/my/bid'
import { MATERIAL_VIEW_FULL } from '@/api/static_api'
import { getToken } from '@/auth/auth'
// initial state
const state = {
  orderList: {},
  orderInfo: {
    orderBaseInfo: {},
    orderProposerList: {},
    orgInfo: {},
    orderExtraCostList: {},
    orderNotaryList: {},
    costViewSwitch: {},
    orderAddServiceList: {},
    orderEvidList: {}
  },
  orderInstrument: {},
  orderMaterial: {},
  orderOrgPay: {},
  orderMsgList: []
}

// getters
const getters = {}

// actions
const actions = {
  // 订单列表
  orderListAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      orderListApi(query).then(response => {
        if (response.status === '2000') {
          commit('setOrderList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 订单列表
  orderInfoAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      orderInfoApi(query).then(response => {
        if (response.status === '2000') {
          commit('setOrderInfo', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 订单列表
  removeOrderInfoAction ({ commit }) {
    commit('setOrderInfo', {})
  },
  // 订单文书
  orderInstrumentAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      orderInstrumentApi(query).then(response => {
        if (response.status === '2000') {
          commit('setOrderInstrument', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 订单材料
  orderMaterialAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      orderMaterialListApi(query).then(response => {
        if (response.status === '2000') {
          response.data.orderMaterialList.forEach(m => {
            m.needMaterialList.forEach(materia => {
              let srcList = []
              if (materia.orderProposerMaterialList) {
                materia.orderProposerMaterialList.forEach(orderProposerMateria => {
                  const src = {
                    src: MATERIAL_VIEW_FULL + '&Token=' + getToken() + '&id=' + orderProposerMateria.id
                  }
                  srcList.push(src)
                })
              }
              materia.previewerSrcList = srcList
              const data = {
                orderId: query.orderId,
                materialCode: materia.materialCode,
                orgNotaryIds: materia.orgNotaryIds
              }
              materia.orderMaterialDesc = {
                materialDetailSynopsis: '',
                hasValue: false
              }
              orderMaterialDescApi(data).then(res => {
                if (res.status === '2000') {
                  materia.orderMaterialDesc = res.data === null ? {} : res.data
                  if ((materia.orderMaterialDesc.materialDetail && materia.orderMaterialDesc.materialDetail.length > 0) || (materia.orderMaterialDesc.materialAttachment && materia.orderMaterialDesc.materialAttachment.length > 0) || (materia.orderMaterialDesc.notaryMaterialDetailList && materia.orderMaterialDesc.notaryMaterialDetailList.length > 0)) {
                    materia.orderMaterialDesc.hasValue = true
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetail === null ? '' : materia.orderMaterialDesc.materialDetail
                    if (materia.orgNotaryIds && materia.orgNotaryIds !== '') {
                      let orgNotaryIdsArr = materia.orgNotaryIds.split(',')
                      if (materia.orderMaterialDesc.notaryMaterialDetailList && materia.orderMaterialDesc.notaryMaterialDetailList.length > 0 && orgNotaryIdsArr.length === materia.orderMaterialDesc.notaryMaterialDetailList.length) {
                        materia.orderMaterialDesc.materialDetailSynopsis = ''
                        materia.orderMaterialDesc.materialDetail = ''
                        materia.orderMaterialDesc.materialAttachment = []
                        materia.orderMaterialDesc.notaryMaterialDetailList.forEach((notaryMaterialDetailObj, index) => {
                          if (notaryMaterialDetailObj.notaryMaterialDetail && notaryMaterialDetailObj.notaryMaterialDetail.length > 0) {
                            materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis + notaryMaterialDetailObj.notaryMaterialDetail
                          }
                        })
                      }
                    }
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis.replace(/<\/?.+?>/g, '')
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis.replace(/ /g, '')
                    materia.orderMaterialDesc.materialDetailSynopsis = materia.orderMaterialDesc.materialDetailSynopsis.replace(/[\r\n]/g, '')
                  }
                  commit('setOrderMaterial', response.data)
                }
              })
            })
          })
          commit('setOrderMaterial', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 订单列表
  removeOrderMaterialAction ({ commit }) {
    commit('setOrderMaterial', {})
  },
  // 订单支付方式
  orderOrgPayAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      orderOrgPayApi(query).then(response => {
        if (response.status === '2000') {
          commit('setOrderOrgPay', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 订单留言列表
  orderMsgListAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      orderMsgListApi(query).then(response => {
        if (response.status === '2000') {
          commit('setOrderMsgList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setOrderList (state, orderList) {
    state.orderList = orderList
  },
  setOrderInfo (state, orderInfo) {
    state.orderInfo = orderInfo
  },
  setOrderInstrument (state, orderInstrument) {
    state.orderInstrument = orderInstrument
  },
  setOrderMaterial (state, orderMaterial) {
    state.orderMaterial = orderMaterial
  },
  setOrderOrgPay (state, orderOrgPay) {
    state.orderOrgPay = orderOrgPay
  },
  setOrderMsgList (state, orderMsgList) {
    state.orderMsgList = orderMsgList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/my/bid.js